<template>
  <div>
    <b-modal
        :id="modalId"
        hide-header
        hide-footer
        centered
    >
      <b-row>
        <b-col sm="10">
         <h3>{{exportName}}</h3>
        </b-col>
        <b-col>
          <close-button
              class="float-right"
              @close-button-click="handleCloseButtonClick"
          />
        </b-col>
      </b-row>
      <hr />
      <p class="my-4">
        <b-form-checkbox
            id="checkbox-1"
            :disabled="true"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
        >
          Entire Book
        </b-form-checkbox>
        <b-form-checkbox
            id="checkbox-1"
            :disabled="true"
            v-model="status"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
        >
          Include Questions
        </b-form-checkbox>
      </p>
      <div v-if="exportTypeId == `email`">
       <export-email
           :curr-idx="currIdx"
           :outputs="outputs"
           @email-sent="handleExportComplete"
       />
      </div>
      <div v-else-if="exportTypeId == 'pdf'">
        <export-pdf
            :curr-idx="currIdx"
            :outputs="outputs"
            @email-sent="handleExportComplete"
        />
      </div>
      <div v-else-if="exportTypeId =='print'">
        Choose printer.
      </div>
      <div v-else>
        <export-copy
            :curr-idx="currIdx"
            :outputs="outputs"
            @words-copied="handleExportComplete"
        />
      </div>
      <div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CloseButton from "@/components/common/closeButton";
import ExportEmail from "./exportEmail";
import ExportPdf from "./exportPdf";
import ExportCopy from "./exportCopy";
export default {
  name: "Display_Export_Modal",
  components: {
    CloseButton,
    ExportEmail,
    ExportPdf,
    ExportCopy
  },
  created(){},
  mounted() {},
  props: {
    modalId: {
      type: String,
      required: false,
      default: "modal-id"
    },
    exportTypeId: {
      type: String,
      required: false,
      default: "modal-id"
    },
    currIdx: {
      type: Number,
      required: false,
      default: 0
    },
    outputs:  {
      type: Array,
      required: false,
      default: ()=>{ return []}
    }
  },
  computed: {
    exportName(){
      return  this.exportTypeId == 'email'? 'Email' :
              this.exportTypeId == 'pdf' ? 'Download' :
                  this.exportTypeId == 'copy' ? 'Copy' :
              this.exportTypeId == 'print' ? 'Print': 'See';
    }
  },
  methods: {
    handleCloseButtonClick(){
      this.$bvModal.hide(this.modalId);
    },
    handleExportComplete(){
      this.$bvModal.hide(this.modalId);
    }
  },
  data() {
    return {
      status:null
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
